import { Location, PopStateEvent } from '@angular/common';
import { Component, OnInit, viewChild } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';

import { TenantComponents } from 'types/Tenant';
import { NavbarComponent } from '../../shared/navbar/navbar.component';
import { SidebarComponent } from '../../sidebar/sidebar.component';
import { ChatbotComponent } from '../../shared/chatbot/chatbot.component';
import { RoleAccessDirective } from '../../shared/directives/role-access.directive';
import { Action, Entity } from '../../types/Authorization';

declare const $: any;

@Component({
  selector: 'app-layout',
  templateUrl: 'admin-layout.component.html',
  styleUrl: 'admin-layout.component.scss',
  imports: [SidebarComponent, NavbarComponent, RouterOutlet, ChatbotComponent, RoleAccessDirective],
})
export class AdminLayoutComponent implements OnInit {
  private readonly sidebar = viewChild<any>('sidebar');
  private readonly navbar = viewChild.required(NavbarComponent);

  public url!: string;
  public location: Location;

  private lastPoppedUrl!: string | null;
  private yScrollStack: number[] = [];

  public constructor(
    private router: Router,
    location: Location,
  ) {
    this.location = location;
  }

  public ngOnInit() {
    const elemMainPanel = document.querySelector('.main-panel') as HTMLElement;
    const elemSidebar = document.querySelector('.sidebar .sidebar-wrapper') as HTMLElement;
    this.location.subscribe((ev: PopStateEvent) => {
      this.lastPoppedUrl = ev && ev.url ? ev.url : null;
    });
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        if (event.url !== this.lastPoppedUrl) {
          this.yScrollStack.push(window.scrollY);
        }
      } else if (event instanceof NavigationEnd) {
        if (event.url === this.lastPoppedUrl) {
          this.lastPoppedUrl = null;
          window.scrollTo(0, this.yScrollStack.pop());
        } else {
          window.scrollTo(0, 0);
        }
      }
    });
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      elemMainPanel.scrollTop = 0;
      elemSidebar.scrollTop = 0;
    });
    const html = document.getElementsByTagName('html')[0];
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      // let ps = new PerfectScrollbar(elemMainPanel);
      // ps = new PerfectScrollbar(elemSidebar);
      html.classList.add('perfect-scrollbar-on');
    } else {
      html.classList.add('perfect-scrollbar-off');
    }
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.navbar().sidebarClose();
    });
  }

  public isMac(): boolean {
    let bool = false;
    if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
      bool = true;
    }
    return bool;
  }

  protected readonly Action = Action;
  protected readonly Entity = Entity;
  protected readonly TenantComponents = TenantComponents;
}
